"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = getImgForFmp;

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _isVisible = _interopRequireDefault(require("./isVisible"));

var _getImgObjFromDom2 = _interopRequireDefault(require("./getImgObjFromDom"));

/**
 * @file 获取某个dom内的所有图片地址
 * @author zhangyanting
 */
function getImgForFmp(e) {
  var _context;

  var imgSrcs = [];
  var imgDoms = [];
  var u = e.tagName.toLowerCase();

  if ((0, _indexOf.default)(_context = ['script', 'style', 'meta', 'head', 'link']).call(_context, u) !== -1) {
    return {
      imgSrcs: imgSrcs,
      imgDoms: imgDoms
    };
  }

  if (!(0, _isVisible.default)(e)) {
    return {
      imgSrcs: imgSrcs,
      imgDoms: imgDoms
    };
  }

  var _getImgObjFromDom = (0, _getImgObjFromDom2.default)(e),
      imgUrl = _getImgObjFromDom.src,
      domContainer = _getImgObjFromDom.domContainer;

  if (imgUrl && !(0, _includes.default)(imgSrcs).call(imgSrcs, imgUrl)) {
    imgSrcs.push(imgUrl);
    imgDoms.push(domContainer);
  }

  var childrensLen = e.children ? e.children.length : 0;

  if (childrensLen > 0) {
    for (var imgChild = e.children, l = childrensLen - 1; l >= 0; l--) {
      var _getImgForFmp = getImgForFmp(imgChild[l]),
          childImgSrcs = _getImgForFmp.imgSrcs,
          childImgDoms = _getImgForFmp.imgDoms;

      if (childImgSrcs.length > 0) {
        imgSrcs = (0, _concat.default)(imgSrcs).call(imgSrcs, childImgSrcs);
        imgDoms = (0, _concat.default)(imgDoms).call(imgDoms, childImgDoms);
      }
    }
  }

  return {
    imgSrcs: imgSrcs,
    imgDoms: imgDoms
  };
}